<template>
  <div>
    <!-- Yandex -->
    <div class="dialog-add-account__form-title">
      {{ $t('business_account_data.type_yandex_agent') }}
    </div>
    <div class="dialog-add-account__form-block">
      <PlatformTypeSelect
        :value="value.yandex"
        :label="$t('business_account_data.type_yandex')"
        :options="yandexOptions"
        :disabled="disabled"
        @input="updateValue('yandex', $event)"
      />
    </div>

    <!-- VK ads -->
    <div class="dialog-add-account__form-title">
      {{ $t('business_account_data.type_vk_ad') }}
    </div>
    <div class="dialog-add-account__form-block">
      <PlatformTypeSelect
        :value="value.vkads"
        :label="$t('business_account_data.choose_type_vk_ad')"
        :options="vkadsOptions"
        :disabled="disabled"
        @input="updateValue('vkads', $event)"
      />
    </div>

    <!-- yandex.promo -->
    <div class="dialog-add-account__form-title">
      {{ $t('user_data.type_yandex_promo') }}
    </div>
    <div class="dialog-add-account__form-block">
      <PlatformTypeSelect
        :value="value.promopages"
        :label="$t('user_data.choose_type_yandex_promo')"
        :options="promopagesOptions"
        :disabled="disabled"
        @input="updateValue('promopages', $event)"
      />
    </div>
  </div>
</template>

<script>
import PlatformTypeSelect from './PlatformTypeSelect.vue';

export default {
  name: 'PlatformSettings',
  components: {
    PlatformTypeSelect,
  },
  props: {
    value: {
      type: Object,
      required: true,
      validator: (value) => {
        const requiredKeys = ['yandex', 'vkads', 'promopages'];
        return requiredKeys.every((key) => key in value);
      },
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    show: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    yandexOptions() {
      return [
        { value: 'default', label: 'AM' },
        { value: 'profitads', label: 'Profitads' },
      ];
    },
    vkadsOptions() {
      return [
        { value: 'default', label: 'AM' },
        { value: 'profitads', label: 'Profitads' },
      ];
    },
    promopagesOptions() {
      return [
        { value: 'default', label: 'AM' },
        { value: 'profitads', label: 'Profitads' },
      ];
    },
  },
  methods: {
    updateValue(key, newValue) {
      // Используем Vue.set для обновления свойства объекта для реактивности Vue 2
      const updated = { ...this.value };
      this.$set(updated, key, newValue);
      this.$emit('input', updated);
    },
  },
};
</script>
